import dayjs, { Dayjs } from 'dayjs';
import { createContext, useContext, useState } from 'react';

type YearPickerContextType = {
  setYear: (year: Dayjs) => void;
  year: dayjs.Dayjs;
  zeitraum: { von: string; bis: string };
};

const YearPickerContext = createContext<YearPickerContextType | undefined>(
  undefined,
);

function YearPickerProvider({ children }: { children: React.ReactNode }) {
  const [year, setYear] = useState<Dayjs>(dayjs());
  const zeitraum = {
    von: year.startOf('year').toISOString(),
    bis: year.endOf('year').toISOString(),
  };
  return (
    <YearPickerContext.Provider value={{ year, setYear, zeitraum }}>
      {children}
    </YearPickerContext.Provider>
  );
}

function useYearPickerContext() {
  const context = useContext(YearPickerContext);
  if (!context) {
    throw new Error('useYearPicker must be used within a YearPickerProvider');
  }
  return context;
}
export { YearPickerContext, YearPickerProvider, useYearPickerContext };
